import { render, staticRenderFns } from "./RefundPolicyText.vue?vue&type=template&id=fcde5df8"
import script from "./RefundPolicyText.vue?vue&type=script&lang=js"
export * from "./RefundPolicyText.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports